const COLORS = ["#6af7c4","#7c6af7","#f7c46a","#f76a8a","#6af7c4","#7c6af7","#f76a8a","#f7c46a"];

// ── Normalize live agent → internal display shape ─────────────
export function normalizeLiveAgent(a, index = 0) {
  const isActive = a.isReporting === 1;
  return {
    id:         a.id,
    name:       a.fullName,
    fullName:   a.fullName,
    initials:   a.fullName.split(" ").map(n => n[0]).join("").toUpperCase().slice(0, 2),
    email:      a.email,
    mobile:     a.mobile,
    role:       "AGENT",
    accountStatus: "on",
    status:     isActive ? "active" : "offline",
    lat:        a.latitude  ? Number(a.latitude)  : null,
    lng:        a.longitude ? Number(a.longitude) : null,
    speed:      a.speed || 0,
    heading:    a.heading ?? a.direction ?? 0,
    battery:    100,
    accuracy:   5,
    address:    a.osmAddress || a.address || "—",
    city:       a.city || "—",
    pincode:    a.pincode || "",
    deviceId:   a.deviceId,
    isReporting:a.isReporting,
    productId:  a.productId ?? null,
    productName:a.productName || "",
    distToday:  0,
    activeTime: "—",
    color:      COLORS[index % COLORS.length],
    lastSeen:   a.timestamp || new Date().toISOString(),
  };
}

// ── Normalize user list entry → internal display shape ─────────
export function normalizeUserAgent(u, index = 0) {
  return {
    id:         u.id,
    name:       u.fullName,
    fullName:   u.fullName,
    initials:   u.fullName.split(" ").map(n => n[0]).join("").toUpperCase().slice(0, 2),
    email:      u.email,
    mobile:     u.mobile,
    role:       u.role,
    accountStatus: u.status === "off" ? "off" : "on",
    status:     u.status === "on" ? "active" : "offline",
    lat:        null,
    lng:        null,
    speed:      0,
    heading:    0,
    battery:    100,
    accuracy:   5,
    address:    u.address || "—",
    city:       u.city || "—",
    pincode:    u.pincode || "",
    distToday:  0,
    activeTime: "—",
    color:      COLORS[index % COLORS.length],
    lastSeen:   u.updatedAt || new Date().toISOString(),
    allowAnyLocation: u.allowAnyLocation,
  };
}

/** Keep deactivated (status=off) agents off every list except Users. */
export function onlyOnAgents(list) {
  return (Array.isArray(list) ? list : []).filter((a) => a && a.status !== "off");
}
